import React, { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import domtoimage from 'dom-to-image';
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import { useSelector, useDispatch } from 'react-redux';
import {
  signatureSelector,
  setChoice,
  setText,
  setImage,
  setDraw,
  setParaphe,
  setFont
} from '../../../../services/reduxSlices/SignatureSlice';
import './Step2.css';
import styles from './step2.module.css'
import { useTranslateContext } from '../../../../hooks';
import { Designed } from '../../../Designed';

/**
 * Etape 2 (Signature) de la fenêtre modale seul signataire
 */
const contentId = 'containerDesigned__2'
export default function Step2() {

  const getParapheBase64 = async () => {
    const contentElement = document.getElementById(contentId)

    // Wait for the fonts to be ready
    await document.fonts.ready;

    domtoimage.toPng(contentElement)
      .then(function (dataUrl) {
        //console.log(dataUrl)
        dispatch(setText(dataUrl))
      })
      .catch(function (error) {
        console.error('oops, something went wrong!', error);
      });
  };

  function getToDay() {
    const maintenant = new Date();

    // Obtenir les composants de la date
    const jour = maintenant.getDate();
    const mois = maintenant.getMonth() + 1; // Les mois commencent à 0, donc on ajoute 1
    const annee = maintenant.getFullYear();
    const heures = maintenant.getHours();
    const minutes = maintenant.getMinutes();
    const secondes = maintenant.getSeconds();

    // Ajouter un zéro devant les chiffres < 10
    const formatJour = (jour < 10) ? `0${jour}` : jour;
    const formatMois = (mois < 10) ? `0${mois}` : mois;
    const formatHeures = (heures < 10) ? `0${heures}` : heures;
    const formatMinutes = (minutes < 10) ? `0${minutes}` : minutes;
    const formatSecondes = (secondes < 10) ? `0${secondes}` : secondes;

    // Retourner la date au format spécifié
    return `${formatJour}-${formatMois}-${annee} ${formatHeures}:${formatMinutes}:${formatSecondes}`;
  }

  const bigFont = ['Lihataja', 'Asem Kandis']

  const fontScript = [
    { name: 'Southam Demo' },
    { name: 'Lihataja' },
    { name: 'Queenstown Signature' },
    { name: 'Bellandha Signature' },
    { name: 'Asem Kandis' }
  ]

  const [selected, setSelected] = useState(fontScript[0].name)
  const [textValue, setTextValue] = useState('')
  const { translate } = useTranslateContext();
  const signature = useSelector(signatureSelector);
  const dispatch = useDispatch();

  const signatureRef = useRef({});

  const handleDisplayChoiceParameters = (choice) =>
    signature.choice === choice ? 'd-flex align-items-center' : 'd-none';
  const handleSetSignatureImage = (e) =>
    dispatch(setImage(URL.createObjectURL(e.target.files[0])));

  const handleSetSignatureDraw = () => {
    dispatch(
      setDraw(signatureRef.current.getTrimmedCanvas().toDataURL('image/png'))
    );
  };

  const handleClearSignatureDraw = () => {
    signatureRef.current.clear();
    dispatch(setDraw(null));
  };

  const handleClearImage = () => {
    document.querySelector('#signature-image').value = null;
    dispatch(setImage(null));
  };

  const onSelectFont = (item) => {
    setSelected(item.name)
    dispatch(setFont(item.name))
  }

  return (
    <div className="d-flex flex-column">
      <div className="d-flex align-items-center mb-5">
        <div className="form-check form-check-custom form-check-solid">
          <input
            className="form-check-input"
            type="radio"
            value="text"
            id="text"
            name="choice"
            defaultChecked
            onClick={() => dispatch(setChoice('text'))}
          />
          <label className="form-check-label" htmlFor="text">
            {translate.admin.deinition}
          </label>
        </div>

        <div className="form-check form-check-custom form-check-solid mx-5">
          <input
            className="form-check-input"
            type="radio"
            value="image"
            id="image"
            name="choice"
            onClick={() => dispatch(setChoice('image'))}
          />
          <label className="form-check-label" htmlFor="image">
            {translate.admin.chargerUneImage}
          </label>
        </div>

        <div className="form-check form-check-custom form-check-solid">
          <input
            className="form-check-input"
            type="radio"
            value="draw"
            id="draw"
            name="choice"
            onClick={() => dispatch(setChoice('draw'))}
          />
          <label className="form-check-label" htmlFor="draw">
            {translate.admin.zoneDeSignature}
          </label>
        </div>
      </div>

      <div className={`py-5 ${styles.container}`}>
        {
          signature.choice === 'text' ?
            <div className={styles.navbar}>
              <span className={styles.leftIcon}>
                <AiOutlineLeft color={'#009EF7'} size={18} />
              </span>

              <div className={styles.display}>
                {
                  fontScript.map((item, key) => (
                    <div onClick={
                      async () => {
                        onSelectFont(item)
                        await getParapheBase64()
                      }
                    } key={key} className={`${styles.policyBox} ${selected === item.name && styles.selected}`}>
                      <label style={{ fontFamily: item.name }}>Your font</label>
                    </div>
                  ))
                }
              </div>

              <span className={styles.rigthIcon}>
                <AiOutlineRight color={'#009EF7'} size={18} />
              </span>
            </div>
            : <span></span>
        }
        <div className={`d-flex align-items-center`}>
          <div className={`${handleDisplayChoiceParameters('text')} ${styles.searchPreview}`}>
            <input
              type="search" className="form-control" defaultValue={textValue} onChange={async e => {
                setTextValue(e.target.value)
                await getParapheBase64()
              }} />
            {/* <label style={}>{signature.text}</label> */}
            <Designed
              id={contentId}
              style={{ fontFamily: selected, fontSize: bigFont.includes(selected) ? '2rem' : '3rem', marginLeft: '1em', minWidth: 'fit-content' }}
              value={textValue}
              date={getToDay()}
            />
          </div>
        </div>

        <div className="d-flex align-items-center">
          <div className={handleDisplayChoiceParameters('image')}>
            <input type="file" id="signature-image" className="form-control" accept='image/*' onChange={handleSetSignatureImage} />

            <div className="position-relative" id="image-container">
              {signature.image && <img src={signature.image} alt="Image de signature" width="100" className='ms-5' />}
              {signature.image && <button type='button' title="Retirer cette image"
                style={{ top: 0, right: 0, width: '10px', height: '10px', padding: '15px' }}
                className='btn btn-danger ms-5 rounded-circle justify-content-center align-items-center position-absolute'
                onClick={() => handleClearImage()}>X
              </button>}
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center">
          <div className={handleDisplayChoiceParameters('draw')}>
            <div className='rounded' style={{ border: '1px solid #E4E6EF' }} id="canvas">
              <SignatureCanvas
                ref={signatureRef}
                canvasProps={{ width: 400, height: 100 }}
                onEnd={() => handleSetSignatureDraw()}
              />
            </div>

            <div className="ms-5 d-flex flex-column">
              <button type='button' className='btn btn-primary' onClick={() => handleClearSignatureDraw()}>{translate.admin.effacer}</button>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-5">
        <div className="d-flex align-items-center mb-5">
          <div className="form-check form-check-custom form-check-solid">
            <input
              className="form-check-input"
              type="checkbox"
              value="paraphe"
              id="paraphe"
              name="option"
              onClick={() => dispatch(setParaphe(!signature.paraphe))}
            />
            <label className="form-check-label" htmlFor="paraphe">
              {translate.admin.paraphe}
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}
